import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { RedirectToLastVisitedProjectPage } from '@jira/router-routes__common/src/ui/last-visited-project-page/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectServiceDeskRoute } from '@jira/router-routes__servicedesk-default-routes/src/projectServiceDeskRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectServiceDeskRouteEntry: Route = createEntry(projectServiceDeskRoute, () => ({
	group: 'servicedesk',
	isRedirect: true,
	// eslint-disable-next-line no-restricted-syntax
	component: RedirectToLastVisitedProjectPage,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [...getServiceDeskNavigationResources(), getConsolidationStateResource()],
	forPaint: [LazyAtlassianNavigation],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
